import { storeInstance } from "store/index.js";
import { httpError } from "store/httpError.js";
import getProductTreeId from "../utils/getProductTreeId";
import debounce from "lodash/debounce";
import * as util from "lib/util.js";
import { async } from "regenerator-runtime";

/**
 * Used to get the root node of the item tree (Useful in placeholder paths)
 * @returns {Object} - Item tree
 */
export const getParentPath = async (externalId) => {
  try {
    const res = await fetch(
      `/kb/jrest/getParentPath?externalId=${externalId}&langCode=${storeInstance.state.langCode}`
    );
    if (!res.ok) {
      httpError(res, storeInstance);
      throw Error;
    }
    return await res.json();
  } catch (e) {
    console.log(e);
  }
};

export const getControlDefData = async (id) => {
  let publicationStr = "";
  let productTreeId = getProductTreeId(storeInstance.state.panel_control_defs);
  if (id === productTreeId) {
    publicationStr = storeInstance.state.filter_helpset_id
      ? `&publicationExtId=${storeInstance.state.filter_helpset_id}`
      : "";
  }
  try {
    const res = await fetch(
      `/kb/jrest/getControlDefData?controlId=${id}&langCode=${storeInstance.state.langCode}` +
        publicationStr
    );
    if (!res.ok) {
      httpError(res, storeInstance);
      throw Error;
    }
    return await res.json();
  } catch (e) {
    console.log(e);
  }
};

/**
 * @param {String} kbrid - kb resource id
 */
export const getResource = async (kbrid) => {
  try {
    const res = await fetch(`/kb/jrest/getResource?kbrid=${kbrid}&setToDownload=true`);
    if (!res.ok) {
      httpError(res, storeInstance);
      throw Error;
    }
    console.log("RES", res)
    let filename = res.headers.get("content-disposition")?.slice(16) // The slice gets rid of inline;filename=
    let blob = await res.blob();
    return [blob, filename];
    // console.log(res.headers.get("Content-type"))
  } catch (e) {
    console.log(e);
  }
};

export const getPanelSearchResults = async () => {
  let searchTerm = storeInstance.state.search_term
    ? storeInstance.state.search_term.searchterm
    : "";
  let panelControlDefsJSon = JSON.stringify(
    util.controlValuesToLstValues(storeInstance.state.control_values)
  );
  let url = `panelControlDefsJSon=${panelControlDefsJSon}&panelName=KbPanel&langCode=${
    storeInstance.state.langCode
  }&startRow=${
    (storeInstance.state.current_results_page - 1) *
      storeInstance.state.max_results +
    1
  }&totRows=${storeInstance.state.max_results}`;
  if (searchTerm) {
    url = url + `&searchText=${searchTerm}`;
  }
  window.scrollTo(0, 0);
  return debounceGetPanelSearchResults(url);
};

let debounceGetPanelSearchResults = debounce(async (url) => {
  PubSub.publish("requestout", null);
  storeInstance.dispatch("setState", {
    property: "is_results_loading",
    value: true,
  });
  try {
    const res = await fetch(`/kb/jrest/getPanelSearchResults`, {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: url,
    });
    if (!res.ok) {
      httpError(res, storeInstance);
      throw Error;
    }
    let data = await res.json();
    storeInstance.commit("search", data.searchResults);
    return data.searchResults;
  } catch (e) {
    console.log(e);
  } finally {
    storeInstance.dispatch("setState", {
      property: "is_results_loading",
      value: false,
    });
    PubSub.publish("requestin", null);
  }
}, 500);

// let debounceGetPanelSearchResults = debounce((url) => {
//   PubSub.publish("requestout", null);
//   storeInstance.dispatch("setState", { property: "is_results_loading", value: true });
//   return fetch(
//     storeInstance.state.kb_rest_server + "/kb/jrest/getPanelSearchResults",
//     {
//       method: "post",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//       body: url,
//     }
//   )
//     .then((response) => {
//       if (!response.ok) {
//         httpError(response, storeInstance);
//         throw Error();
//       }
//       return response.json();
//     })
//     .then((data) => {
//       storeInstance.commit("search", data.searchResults);
//     })
//     .catch(function (error) {})
//     .finally(function () {
//       storeInstance.dispatch("setState", {
//         property: "is_results_loading",
//         value: false,
//       });
//       PubSub.publish("requestin", null);
//     });
// }, 500);
